/* eslint-disable no-console */
import { call, select } from 'typed-redux-saga'
import { authSelector } from 'Pages/auth'
import { socketApi, WorkerEvent } from 'Modules'
import { getBaseSocketUrl } from '@pp/axios'

export function* createWsConnection() {
	try {
		const user_id = yield* select(authSelector.getUserIdSelector)
		const ticket = yield* call(socketApi.getTicket, user_id)
		const baseUrl = getBaseSocketUrl()
		const url = `${baseUrl}?ticket=${ticket}`
		navigator.serviceWorker.controller.postMessage({
			type: WorkerEvent.CONNECT_SOCKET,
			payload: url,
		})
	} catch (e) {
		console.log(e)
	}
}
